var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { cartSummaryListCls, cartSummaryListRowCls, cartSummaryListRowLineCls, cartSummaryListLabelCls } from "./Summary.less";
function CartSummaryList(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryListCls
  }, children);
}
__name(CartSummaryList, "CartSummaryList");
function CartSummaryListRow(_ref2) {
  var children = _ref2.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryListRowCls
  }, children);
}
__name(CartSummaryListRow, "CartSummaryListRow");
function CartSummaryListRowLine(_ref3) {
  var label = _ref3.label, children = _ref3.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryListRowLineCls
  }, label && children ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
    className: cartSummaryListLabelCls
  }, label), /* @__PURE__ */ React.createElement("div", null, children)) : children);
}
__name(CartSummaryListRowLine, "CartSummaryListRowLine");
export {
  CartSummaryList,
  CartSummaryListRow,
  CartSummaryListRowLine
};
